import geoService from "@/services/geo";
import { useQuery } from "@tanstack/react-query";

function useGetAddressByCoordination(lat: number, lng: number) {
  return useQuery({
    queryKey: ["getAddress", lat, lng],
    queryFn: () => geoService.getAddress(lat, lng),
    select: (res) => res?.data,
    enabled: !!lat && !!lng,
  });
}

export default useGetAddressByCoordination;
